import fetch from './index'
import { Loading } from 'element-ui';

export default {
    async rCaptcha(){
        let res = await fetch({
            url: 'common/captcha',
            isGet: true
        })
        return res;
    },
    async upload(url, formData){
        let res = await fetch({
            url: url,
            formData: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return res;
    },
    async rApi(url, data,loading = false) {
        if (!data) {
            data = {}
        }
        let loadingObj = null;
        if(loading){
            loadingObj = Loading.service({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.6)'
            });
        }
        let res = null;
        try{
            res = await fetch({
                url: url,
                data
            })
        }catch(e){
            if(loading){
                loadingObj.close();
            }            
        }
        if(loading){
            loadingObj.close();
        }
        return res;
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/api/common.js